export default __webpack_public_path__ + "static/media/splitConduits2.2e0e9339.jpg";